<div *ngIf=field.label class="container-title" [ngStyle]="field.styles?.title" [innerHTML]="field.label | gioNoSanitize">

</div>
<div class="container-fields" [ngStyle]="field.styles?.container">
  <ng-container *ngFor="let item of field.fields;">
    <ng-container *ngIf="item.visible" [service]="service" [field]="item" [group]="group"
      gioFormField>
    </ng-container>
  </ng-container>


</div>
